export default {
    totals: 'Totals',
    grand_total: 'Grand Total',
    work_type: 'Activities',
    quantity: 'Quantity',
    total_time: 'Total Time',
    call: {
        category: 'Category',
        total_ticket: 'Total Tickets',
        total_worklload: 'Total Workloads',
    },
}
